import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { CurrencyCircleEuroIcon } from '@moia-dev/pace-icons'
import { ApPricingAreaRoutes } from './ApPricingAreaRoutes'

export const ApPricingAreaNavigationIcon = CurrencyCircleEuroIcon

export const ApPricingAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={ApPricingAreaRoutes.route}
      Icon={CurrencyCircleEuroIcon}
    />
  )
}
